<template>
    <div>
         <headerNav title="订单管理"/>
         <div class="mz-main">
             <div class="mian-list" @click="goto('myorder',0)">
                <div class="mian-list-cont">
                   <van-icon class="main-list-icon-right"  :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="quanbu" />
                   <div >全部订单</div>
                   <van-icon class="main-list-icon-left" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
                </div>
             </div>
             <div class="mian-list" @click="goto('myorder',1)">
                <div class="mian-list-cont">
                <van-icon class="main-list-icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="daifukuan" />
                <div >待付款订单</div>
                <van-icon class="main-list-icon-left" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
                 </div>
             </div>
             <div class="mian-list" @click="goto('myorder',2)">
                <div class="mian-list-cont">
                <van-icon class="main-list-icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="daifahuo" />
                <div >待发货订单</div>
                <van-icon class="main-list-icon-left" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
                 </div>
             </div>
             <div class="mian-list" @click="goto('myorder',3)">
                <div class="mian-list-cont">
                <van-icon class="main-list-icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="yifahuo" />
                <div >已发货订单</div>
                <van-icon class="main-list-icon-left" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
                </div>
             </div>
             <div class="mian-list" @click="goto('myorder',4)">
                <div class="mian-list-cont">
                <van-icon class="main-list-icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="dingdan" />
                <div >已签收订单</div>
                <van-icon class="main-list-icon-left" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
                 </div>
             </div>
             <div class="mian-list" @click="goto('myorder',5)">
                <div class="mian-list-cont">
                <van-icon class="main-list-icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="tuikuan" />
                <div >退款订单</div>
                <van-icon class="main-list-icon-left" :size="$abctheme.fontbig" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="you" />
                 </div>
             </div>
         </div>
    </div>
</template>
<script>
export default {
      data()
      {
         return {};
      },
      methods:
      {
         goto(name,state)
         {
             
             if(state)
             {
                this.$router.push({name:name,query:{state:state}});
             }
             else
             {
                 this.$router.push({name:name});
             }
         }
      }
}
</script>
<style lang="scss" scoped>
.mz-main
{
  position: relative;  
  font-size: 25px;
  margin: 20px 10px 80px 10px;
}
.mian-list
{
    padding: 20px 0 20px 0;
    background-color: rgb(179,197,135);
    border-radius: 4px;
    box-shadow: 2px 2px 4px #bbb;
    margin-top:20px ;
}
.mian-list-cont
{
   padding: 0 28px 0 65px;
   position: relative;
}
.main-list-icon-right
{
   position:absolute;
   top:-7px;
   left:10px;
}
.main-list-icon-left
{
   position:absolute;
   right: 10px;
   top:-5px;
}
</style>